import { ErrorPage } from '@common/ErrorPage'
import { LoadingPage } from '@common/LoadingPage'
import { AnimatedPage } from '@components/index'
import { useTicketDetail } from '@services/tickets/queries/useTicketDetail'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import { Card } from '@/components/ui/card'

import {
  AttachmentChips,
  TicketCommentThread
} from '../../components/TicketCommentThread'
import { TicketPriorityPill, TicketStatusPill } from '../../components/TicketPills'
import { useIntlLocale } from '@/i18n/languages'

export function TicketDetail() {
  const { id } = useParams()
  const { t } = useTranslation('tickets')
  const { data: ticket, isLoading } = useTicketDetail(id)
  const locale = useIntlLocale()

  if (isLoading) return <LoadingPage />
  if (!ticket) return <ErrorPage />

  return (
    <AnimatedPage>
      <div className="mx-auto w-full max-w-[900px] space-y-5">
        <Link
          to="/user/tickets"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('detail.back')}
        </Link>

        <Card className="space-y-4 p-6">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="m-0 flex-1 font-display text-xl font-bold text-ink">
              {ticket.title}
            </h1>
            <TicketStatusPill status={ticket.status} />
            <TicketPriorityPill priority={ticket.priority} />
          </div>

          <div className="text-sm text-muted-foreground">
            {t(`categories.${ticket.category}`)}
            {' · '}
            {new Date(ticket.created_at).toLocaleDateString(locale)}
            {ticket.flat?.title ? ` · ${ticket.flat.title}` : ''}
          </div>

          {ticket.description && (
            <p className="m-0 whitespace-pre-wrap text-sm leading-relaxed text-ink">
              {ticket.description}
            </p>
          )}

          <AttachmentChips ticketId={ticket.id} attachments={ticket.attachments} />
        </Card>

        <Card className="p-6">
          <TicketCommentThread ticket={ticket} />
        </Card>
      </div>
    </AnimatedPage>
  )
}
